export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
          投稿联系
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
          你有私藏的冷门佳片想分享？有独到的观影见解想表达？欢迎通过以下方式与我们联系。编辑团队珍视每一份来自影迷的真诚推荐，优质投稿将有机会出现在精选推荐栏目中，与更多同好分享你的电影品味。
        </p>
        <div className="inline-flex flex-col sm:flex-row items-center gap-4 bg-background-50 rounded-lg px-6 py-4 border border-background-200/70">
          <div className="flex items-center gap-2 text-foreground-700">
            <i className="ri-mail-line text-primary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="text-sm">contact@91freevideo.com</span>
          </div>
          <span className="hidden sm:block text-foreground-300">|</span>
          <div className="flex items-center gap-2 text-foreground-700">
            <i className="ri-wechat-line text-primary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="text-sm">91video_official</span>
          </div>
        </div>
      </div>
    </section>
  );
}